import { Order } from '@seen/core/models/orders/Order'
import { resolveId } from '@seen/core/references'
import { Loader, useRead } from '@seen/react'
import type { JSX } from 'react'
import { Navigate, useParams } from 'react-router'

export function OrderRedirectPage(): JSX.Element {
  const { orderId } = useParams<{ orderId?: string }>()
  const { data: order, isLoading } = useRead(Order, orderId, {
    query: { enabled: !!orderId },
  })

  if (!orderId) {
    return <Navigate to="/orders" replace />
  }

  if (isLoading) {
    return <Loader />
  }

  if (!order) {
    return <Navigate to="/orders" replace />
  }

  const patientId = resolveId(order.participant)
  if (!patientId) {
    return <Navigate to="/orders" replace />
  }

  return <Navigate to={`/Patient/${patientId}/orders/${orderId}`} replace />
}
